import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const RightPanel = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 3V13L14 13V3H11ZM10 13V3L2 3V13H10ZM1 3C1 2.44772 1.44772 2 2 2H11H14C14.5523 2 15 2.44772 15 3V13C15 13.5523 14.5523 14 14 14H11H2C1.44772 14 1 13.5523 1 13V3Z"
        />
      </svg>
    )
  },
)

export default RightPanel
